export function CreateSingleton<T>(func: () => T): () => T {
  let res: T
  return () => res ?? (res = func())
}
